<template>
	<view class="page-wrapper">
		<div class="bg-top"></div>

		<!--<view class="text-2xl font-bold mb-4 text-center">🏨 酒店介绍</view>	-->

		<div class="content-wrapper">


			<!-- 图片1 -->
			<view class="px-8"> <!-- 左右 padding 4 -->
				<image src="https://farm.evcc.top/Uploads/yuanboyuan/hotels/01.jpg"
					class="w-full rounded-lg  object-cover" mode="aspectFill" />
				<view class="text-lg font-semibold" style="text-align:center">九派通苑</view>
			</view>

			<!-- 酒店信息 -->
			<view class="w-full p-6 rounded-lg space-y-2">
				<view style="text-indent: 2em;">九派通苑·城控凯瑞酒店由荆门市城控集团投资兴建，武汉格林凯瑞酒店管理公司运营管理，是荆门城区首家按照国际五星级标准兴建的中式园林合院酒店。
				</view>
				<view style="text-indent: 2em;">酒店毗邻风景秀丽的荆门园博园及市政务中心，传承发扬中国建筑文化之绝妙，亭台楼阁遥相呼应，小桥流水曲径通幽，实现了建筑与自然的完美结合。
				</view>
				<view style="text-indent: 2em;">
					酒店总营业面积16000平方米。古色古香的竹韵楼、兰馨楼，拥有风格迥异的14个贵宾包厢、2个庭院风格宴会大厅，可容纳680人同时进餐，汇聚本地精品家常菜、粤菜、川菜、湘菜、楚菜等各类五湖四海精英大厨;全景落地、环境幽雅的全日制茶餐厅，品类丰富的自助餐品，最具代表的地方小食，满足您对美食的一切期待;粉墙黛瓦、庭院深邃的菊香楼、梅芳楼、松涛楼，拥有小庭雅苑客房118间，床位数230个，静坐窗前尽是“满园春色惹人醉，诗情画意情满怀”。
				</view>
			</view>
			<view style="height:100rpx"></view>

			<!-- 图片2 -->
			<view class="px-8"> <!-- 左右 padding 4 -->
				<image src="https://farm.evcc.top/Uploads/yuanboyuan/hotels/02.jpg"
					class="w-full rounded-lg object-cover" mode="aspectFill" />
				<view class="text-lg font-semibold" style="text-align:center">南苑民宿</view>
			</view>

			<!-- 酒店信息 -->
			<view class="w-full  p-6 rounded-lg space-y-2">
				<view style="text-indent: 2em;">
					荆门园博园南苑民宿是荆门园博园运营有限公司依托园区生态资源打造的特色住宿项目，共投资建设15栋木结构民宿（共25间客房），通过园区森林庭院与非遗文化体验的深度融合，塑造“大隐于市”的生态旅居目的地。
				</view>
				<view style="text-indent: 2em;">项目联动九派通凯瑞酒店及漳河新区商业体，构建“住宿+餐饮+文化”一站式消费闭环。</view>

			</view>
		</div>

		<div class="bg-bottom"></div>

	</view>
</template>


<script>
	export default {
		name: 'Hotel',
		data() {
			return {
				// 可以在这里扩展酒店数据
			}
		}
	}
</script>

<style>
	.flex {
		display: flex;
	}

	.flex-col {
		flex-direction: column;
	}

	.space-y-4 {
		margin-top: 1rem;
		/* 16px */
	}

	.text-2xl {
		font-size: 1.5rem;
		/* 24px */
		line-height: 2rem;
		/* 32px */
	}

	.font-bold {
		font-weight: 700;
	}

	.mb-4 {
		margin-bottom: 1rem;
	}

	.text-center {
		text-align: center;
	}

	.px-8 {
		padding-left: 2rem;
		padding-right: 1rem;
	}

	.w-full {
		width: 90%;
	}

	.rounded-lg {
		border-radius: 0.5rem;
		/* 8px */
	}

	.shadow-md {
		box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	}

	.object-cover {
		object-fit: cover;
	}

	.bg-white {
		background-color: #ffffff;
	}

	.p-6 {
		padding: 1.5rem;
		/* 24px */
	}

	.rounded-lg {
		border-radius: 0.5rem;
	}

	.shadow {
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1),
			0 1px 2px rgba(0, 0, 0, 0.06);
	}

	.space-y-2 {
		margin-top: 0.5rem;
		/* 8px */
	}

	.text-lg {
		font-size: 1.125rem;
		/* 18px */
		line-height: 1.75rem;
	}

	.font-semibold {
		font-weight: 600;
	}

	.pl-4 {
		padding-left: 1rem;
	}

	.list-disc {
		list-style-type: disc;
	}

	.list-inside {
		list-style-position: inside;
	}
	
	.page-wrapper {
	  position: relative;
	  min-height: 100vh; /* 确保小内容时填满视口 */
	  overflow: hidden;
	}
	
	/* 顶部背景 */
	.bg-top {
	  position: absolute;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 500rpx; /* 可用固定像素或图片高度 */
	  background: url('https://farm.evcc.top/Uploads/yuanboyuan/background/bg_top.jpg') no-repeat top center;
	  background-size: cover;
	  z-index: 0;
	}
	
	/* 底部背景 */
	.bg-bottom {
	  position: absolute;
	  bottom: 0;
	  left: 0;
	  width: 100%;
	  height: 500rpx; /* 可用固定像素或图片高度 */
	  background: url('https://farm.evcc.top/Uploads/yuanboyuan/background/bg_bottom.jpg') no-repeat bottom center;
	  background-size: cover;
	  z-index: 0;
	}
	
	/* 内容层 */
	.content-wrapper {
	  position: relative;
	  z-index: 1;
	  padding: 2rem 1rem;
	}
</style>